/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Legacy_Menu } from '../models/Legacy_Menu';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DefaultService {
    /**
     * menu restaurace v daném hypermarketu
     * Detail hypermarketu
     *
     * @returns any menu restaurace v daném hypermarketu
     * @throws ApiError
     */
    public static getApiHypermarketsMenu({
        legacyApiVersion,
        marketId,
    }: {
        legacyApiVersion: '2_6' | '2_8',
        /**
         * Id hypermarketu
         */
        marketId: number,
    }): CancelablePromise<{
        status?: number;
        data?: Array<Legacy_Menu>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/{legacyApiVersion}/hypermarkets/{market_id}/menu',
            path: {
                'legacyApiVersion': legacyApiVersion,
                'market_id': marketId,
            },
        });
    }
    /**
     * Log simple message
     * @returns void
     * @throws ApiError
     */
    public static loggerLog({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: {
            message: string;
        },
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/logger/log',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error.`,
            },
        });
    }
    /**
     * Get autocomplete data from Luigis Box
     * @returns any Response data
     * @throws ApiError
     */
    public static luigiAutocomplete({
        query,
        warehouse,
        apiVersion = 1,
    }: {
        /**
         * Searched string
         */
        query: string,
        /**
         * Warehouse id for filtering by availability
         */
        warehouse: number,
        apiVersion?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/luigi/autocomplete',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'query': query,
                'warehouse': warehouse,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get autocomplete data from Luigis Box
     * @returns any Response data
     * @throws ApiError
     */
    public static luigiSearch({
        query,
        warehouse,
        apiVersion = 1,
    }: {
        /**
         * Searched string
         */
        query: string,
        /**
         * Warehouse id for filtering by availability
         */
        warehouse: number,
        apiVersion?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/luigi/search',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'query': query,
                'warehouse': warehouse,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal server error`,
            },
        });
    }
}
